export const londonBoroughsData = [
    { borough: "City of Westminster", value: 85.4 },
    { borough: "Camden", value: 76.2 },
    { borough: "Greenwich", value: 68.9 },
    { borough: "Hackney", value: 72.5 },
    { borough: "Hammersmith and Fulham", value: 79.3 },
    { borough: "Islington", value: 81.7 },
    { borough: "Kensington and Chelsea", value: 88.1 },
    { borough: "Lambeth", value: 74.6 },
    { borough: "Lewisham", value: 67.3 },
    { borough: "Southwark", value: 75.8 },
    { borough: "Tower Hamlets", value: 77.9 },
    { borough: "Wandsworth", value: 82.4 },
    { borough: "City of London", value: 90.2 },
    { borough: "Barking and Dagenham", value: 58.7 },
    { borough: "Barnet", value: 71.5 },
    { borough: "Bexley", value: 63.2 },
    { borough: "Brent", value: 69.4 },
    { borough: "Bromley", value: 70.8 },
    { borough: "Croydon", value: 65.9 },
    { borough: "Ealing", value: 73.1 },
    { borough: "Enfield", value: 64.5 },
    { borough: "Haringey", value: 70.3 },
    { borough: "Harrow", value: 68.7 },
    { borough: "Havering", value: 61.4 },
    { borough: "Hillingdon", value: 66.8 },
    { borough: "Hounslow", value: 69.7 },
    { borough: "Kingston upon Thames", value: 77.2 },
    { borough: "Merton", value: 75.1 },
    { borough: "Newham", value: 62.8 },
    { borough: "Redbridge", value: 67.5 },
    { borough: "Richmond upon Thames", value: 83.6 },
    { borough: "Sutton", value: 71.9 },
    { borough: "Waltham Forest", value: 66.3 }
];